import clsx from "clsx";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import { IClass } from "../../../pages/teacher/types";
import {
  classPath,
  classDataPath,
  activeLearningClassDataPath,
} from "../../../teacherStore";

import styles from "./Class.module.scss";

export type Props = {
  item: IClass;
  forward?: boolean;
  forwardData?: boolean;
  isActive?: boolean;
  onChooseClass?: (id: number, assumed_entrance_year?: number) => void;
};

const Class: React.FC<Props> = ({
  item,
  forward = false,
  forwardData = false,
  isActive = false,
  onChooseClass,
}) => {
  const history = useHistory();
  const location = useLocation();
  const isActiveLearningParams = new URLSearchParams(location.search).get(
    "isActiveLearning",
  );

  return (
    <button
      className={clsx(styles.class, isActive && styles.active)}
      disabled={!item.charged}
      onClick={() => {
        if (onChooseClass) {
          item.assumed_entrance_year
            ? onChooseClass(item.id, item.assumed_entrance_year)
            : onChooseClass(item.id);
        }
        if (forward) {
          let path = `${classPath}/${item.id}`;
          let state = null;

          if (forwardData) {
            path = isActiveLearningParams
              ? `${activeLearningClassDataPath}/${item.id}`
              : `${classDataPath}/${item.id}`;
            state = { nameClass: item.name };
          }

          history.push(path, state);
        }
      }}
    >
      {item.charged && <span>担当</span>}
      <p>{item.name}</p>
    </button>
  );
};

export default Class;
